/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Builder_HintInputs */

const cs_pipelines_builder_hint = /** @type {(inputs: Pipelines_Builder_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte pipeline a otevře se editor fází — přetažením seřaďte, barvy se projeví na nástěnkách.`)
};

const en_pipelines_builder_hint = /** @type {(inputs: Pipelines_Builder_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a pipeline to open the stage editor — drag to reorder, colors carry onto boards.`)
};

/**
* | output |
* | --- |
* | "Pick a pipeline to open the stage editor — drag to reorder, colors carry onto boards." |
*
* @param {Pipelines_Builder_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_builder_hint = /** @type {((inputs?: Pipelines_Builder_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Builder_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_builder_hint(inputs)
	return cs_pipelines_builder_hint(inputs)
});